// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__NOQ0x"};